// import "../css/sidemenu.css";
import sidemenucss from "../css/sidemenu.module.css"
import { ReactComponent as BaseCorp } from "../assets/icons/base-corp.svg";

const SideMenu = ({ title, menuItems, activeItem }) => {
    const redirectTo = (link)=>{
        window.location.href=link
    }
    return (
        <div className={sidemenucss.sidemenuContainer}>
            <div className={sidemenucss.sidemenuHeader}>
                {/* <BaseCorp className="basecorp-placeholder"/> */}
                <span className={sidemenucss.sidemenuTitle}>{title}</span>
            </div>
            <div className={sidemenucss.sidemenuContent}>
                <ul className={sidemenucss.sidemenuList}>
                    {menuItems.map((item, index) => (
                        <li key={index} onClick={()=>{redirectTo(item.link)}} className={`${sidemenucss.sidemenuItem} ${activeItem === item.label ? sidemenucss.sidemenuItemActive : ''}`}>
                           <span className={sidemenucss.sidemenuItemname}> {item.label}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default SideMenu;